<div class="modal inmodal fade in parcel-modal create-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Disabled Dates</h4>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm start-end-date inlineDateAndTime">
                        <div class="col-md-4">
                            <label>From</label>
                        </div>
                        <div class="col-md-8">
                            <!-- ___ Start Date  ___ -->
                            <mat-form-field>
                                <input matInput
                                       [(ngModel)]="startDate"
                                       name="startDate"
                                       [matDatepickerFilter]="myFilter"
                                       [min]="minDate"
                                       (ngModelChange)="onStartDateChange()"
                                       (focus)="startDatePicker.open()"
                                       (click)="startDatePicker.open()"
                                       [matDatepicker]="startDatePicker"
                                       placeholder="Choose a date">
                                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row m-b-sm start-end-date inlineDateAndTime">
                        <div class="col-md-4">
                            <label>To</label>
                        </div>
                        <div class="col-md-8">
                            <!-- ___ End Date  ___ -->
                            <mat-form-field>
                                <input matInput
                                       [(ngModel)]="endDate"
                                       name="endDate"
                                       [min]="startDate"
                                       (focus)="endDatePicker.open()"
                                       (click)="endDatePicker.open()"
                                       [matDatepicker]="endDatePicker"
                                       placeholder="Choose a date"
                                       [matDatepickerFilter]="myFilter"
                                       [disabled]="!startDate">
                                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #endDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Note</label>
                        </div>
                        <div class="col-md-8">
                            <textarea
                                class="form-control"
                                [(ngModel)]="note"
                                name="note"
                                maxlength="255"
                                placeholder="Type note"
                                [disabled]="!startDate && !endDate">
                                </textarea>
                            <span class="text-muted">{{ note.length }}/255</span>
                        </div>
                    </div>
                    <div class="row m-b-sm">
                        <div class="col-md-12">
                            <div class="pull-right clickable mtv-primary-color" (click)="addDisabledDates()">
                                <i class="fa fa-plus"></i> <span class="bold">Add</span>
                            </div>
                        </div>
                    </div>

                    <!-- ___ Pre Set Disabled Dates ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Preset Dates</label>
                        </div>
                        <div class="col-md-8" style="display: flex;">
                            <select ngModel name="preSetDisabledDates" class="form-control">
                                <option value="" hidden></option>
                                <option value="canadianHolidays">Canadian Holidays 2019</option>
                                <option value="canadianHolidays2020">Canadian Holidays 2020</option>
                                <option value="canadianHolidays2021">Canadian Holidays 2021</option>
                                <option value="canadianHolidays2022">Canadian Holidays 2022</option>
                            </select>
                        </div>
                    </div>
                    <div class="row m-b-sm">
                        <div class="col-md-12">
                            <div class="pull-right clickable mtv-primary-color" (click)="addPresetDiabledDates()">
                                <i class="fa fa-plus"></i> <span class="bold">Add</span>
                            </div>
                        </div>
                    </div>

                    <table class="dates-table" *ngIf="disabledDatesArray.length">
                        <thead>
                        <tr>
                            <th>From</th>
                            <th>To</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let item of disabledDatesArray; let isLast = last; let index = index">
                            <tr (mouseover)="focusedDisabledDateIndex = index"
                                [class.focused]="focusedDisabledDateIndex === index" class="date-row">
                                <td>{{item.startDate | date:'dd.MM.yyyy':'+0000'}}</td>
                                <td>{{item.endDate | date:'dd.MM.yyyy':'+0000'}}</td>
                                <td [attr.rowspan]="item.note ? 2 : 1">
                                    <i class="fa fa-trash" title="Delete Attachment"
                                       (click)="deleteDisabledDates(item)"></i>
                                </td>
                            </tr>
                            <tr *ngIf="item.note" (mouseover)="focusedDisabledDateIndex = index"
                                [class.focused]="focusedDisabledDateIndex === index">
                                <td colspan="2">
                                    <b>
                                        Note
                                    </b>
                                    <div style="white-space: pre-line;">
                                        {{ item.note }}
                                    </div>
                                </td>
                            </tr>
                            <tr [class.visibleLine]="!isLast" (mouseover)="focusedDisabledDateIndex = index"
                                [class.focused]="focusedDisabledDateIndex === index">
                                <td colspan="3" class="date-divider"></td>
                            </tr>
                        </ng-container>
                        </tbody>
                    </table>

                    <div class="row text-center m-b-md m-t-md">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/disabled-dates-modal/disabled-dates-modal.component.html